import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationValuationBlockStructureTypeConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationValuationBlockStructureTypes";
    static FUNCTION_DELETE_MULTIPLE_PROPERTY_VALUATION_BLOCK_STRUCTURE_TYPES = "DeleteMultipleValuationBlockStructureTypes";
    static FUNCTION_UPLOAD_VALUATION_BLOCK_STRUCTURE_TYPES = "UploadValuationBlockStructureTypes";
}
